import { Box } from "@mui/material";
import InviteView from "../views/InviteView";

const InvitePage = () => {
  return (
    <Box>
      <InviteView />
    </Box>
  );
};

export default InvitePage;
